var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-entity",
    [
      _c(
        "a-yoga-layout",
        {
          staticClass: "clickable",
          attrs: {
            "width-auto": "1",
            "height-auto": "1",
            padding: "0.02",
            "flex-wrap": "wrap",
            "flex-direction": "column",
            "align-items": "center",
            "justify-content": "center",
            geometry: "primitive: rounded-plane;",
            material: "color: #001034;",
            "push-mesh-backwards": "distance: 0.02",
          },
        },
        [
          _c(
            "a-yoga-layout",
            {
              attrs: {
                "width-auto": "1",
                "height-auto": "1",
                padding: "0",
                "flex-wrap": "wrap",
                "flex-direction": "row",
                "align-items": "center",
                "justify-content": "space-between",
                "yoga-layout-item": "margin: 0.01; marginEdge: vertical",
                geometry: "primitive: plane;",
                material: "visible: false",
              },
            },
            [
              _c("a-image", {
                staticClass: "clickable",
                attrs: {
                  src: "/aframe-assets/icons/home.png",
                  width: "0.05",
                  height: "0.05",
                  "yoga-layout-item": "margin: 0.02; marginEdge: horizontal",
                  "ui-icon": "",
                  "play-sound": "audio: #audio-bop; events: click",
                },
                on: {
                  click: function ($event) {
                    return _vm.setFirstPage()
                  },
                },
              }),
              _vm._v(" "),
              _c("a-image", {
                staticClass: "clickable",
                attrs: {
                  id: "navigationIcon",
                  src: "/aframe-assets/icons/menu.png",
                  width: "0.05",
                  height: "0.05",
                  "yoga-layout-item": "margin: 0.02; marginEdge: horizontal",
                  "ui-icon": "",
                  "play-sound": "audio: #audio-bop; events: click",
                  "toggle-modal": "#navigationPanel",
                },
              }),
              _vm._v(" "),
              _c("a-image", {
                ref: "exitIcon",
                staticClass: "clickable",
                attrs: {
                  id: "exitIcon",
                  src: "/aframe-assets/icons/logout.png",
                  width: "0.05",
                  height: "0.05",
                  "yoga-layout-item": "margin: 0.02; marginEdge: horizontal",
                  "ui-icon": "",
                  "play-sound": "audio: #audio-bop; events: click",
                  "exit-vr-button": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-yoga-layout",
            {
              attrs: {
                "width-auto": "1",
                "height-auto": "1",
                padding: "0",
                "flex-wrap": "nowrap",
                "flex-direction": "row",
                "align-items": "center",
                "justify-content": "space-between",
                "yoga-layout-item": "margin: 0.02; marginEdge: top",
                geometry: "primitive: plane;",
                material: "visible: false",
              },
            },
            [
              _c("a-image", {
                attrs: {
                  src: "/aframe-assets/images/siemens-icon.png",
                  width: "0.02",
                  height: "0.02",
                },
              }),
              _vm._v(" "),
              _c(
                "a-entity",
                {
                  attrs: {
                    "html-dev": "autoEnable: true",
                    geometry: "primitive: plane; width:0.1; height: 0",
                    material: "visible: false; transparent: true",
                    "yoga-layout-item":
                      "margin: 0.01; marginEdge: left; padding: 0",
                  },
                },
                [
                  _c("div", { staticClass: "vr" }, [
                    _c("p", { staticClass: "small" }, [
                      _vm._v("\n                    " + _vm._s(_vm.title)),
                      _c("br"),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            this.$parent.settings
                              ? this.$parent.settings.copyright
                              : ""
                          ) +
                          "\n                  "
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-yoga-layout",
            {
              attrs: {
                "width-auto": "1",
                "height-auto": "1",
                padding: "0",
                "flex-wrap": "nowrap",
                "flex-direction": "row",
                "align-items": "center",
                "justify-content": "space-between",
                "yoga-layout-item": "margin: 0.02; marginEdge: top",
                geometry: "primitive: plane;",
                material: "visible: false",
              },
            },
            _vm._l(_vm.sites, function (site) {
              return _c("a-image", {
                key: "i" + site.id,
                staticClass: "clickable",
                attrs: {
                  src: "/img/locale/" + site.locale.lang + ".png",
                  width: "0.155",
                  height: "0.07",
                  "yoga-layout-item":
                    "margin: 0.01; marginEdge: left; padding: 0",
                  "ui-icon": "",
                  "play-sound": "audio: #audio-bop; events: click",
                },
                on: {
                  click: function ($event) {
                    return _vm.setSite(site)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }